import React from 'react'
import {ReactComponent as LinkedInIcon} from '../media/icons/linkedin.svg';
import {ReactComponent as GitHubIcon} from '../media/icons/github.svg';
import {ReactComponent as BehanceIcon} from '../media/icons/behance.svg';

function SocialMedia() {
    return (
        <div className="social-media-container">
            <a href="https://www.linkedin.com/in/kirsten-kwan/" target="_blank" rel="noopener noreferrer"><LinkedInIcon alt="LinkedIn Icon" className="linkedin-icon"/></a>
            
            <a href="https://github.com/kirstenkwan" target="_blank" rel="noopener noreferrer"><GitHubIcon alt="GitHub Icon" className="github-icon"/></a>
            <a href="https://www.behance.net/kirstenkwan" target="_blank" rel="noopener noreferrer"><BehanceIcon alt="Behance Icon" className="behance-icon"/></a>
            
        </div>
    )
}

export default SocialMedia
